import type { Section, SectionTargetField } from 'src/core/contexts/PatientContactContext'

const getAllTargetContent = (sections: Section[], targetField: SectionTargetField, removeEmptySections = false) => {
	const targetSections = sections.filter((section) => section.target_field === targetField)
	const singleSection = targetSections.length === 1
	return targetSections
		.map(({ title, content }) => {
			if (removeEmptySections && !content) {
				return ''
			}

			return singleSection || !title ? content : `${title}:\n\n${content ?? ''}`
		})
		.filter((content) => !!content)
		.join('\n\n')
}

export default getAllTargetContent
